import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { AuthService } from '../services/auth.service';
import { SessionService } from '../services/session.service';
@Component({
  standalone:true,
  imports:[
    CommonModule,
    FormsModule,
    RouterLink,
    RouterLinkActive
  ],

  template:`
    <div class="login-card">
    <div class="spinner-container" *ngIf="isLoadingPageContent">
      <span class="spinner"></span>
    </div>
    </div>
    <div class="overlay" *ngIf="showAlert">
      <div class="alert-modal">
        <p class="pin-text">
            {{ errorMessage }}
        </p>
        <div class="btns">
          <button
            class="primary"
            (click)="closeErrorPopup()">
            Close
          </button>
        </div>
      </div>
    </div>
  `
})
export class RegisterPage{
 userNumber = '';
 showAlert = false;
 errorMessage = '';
 isLoadingPageContent = true;
  whatsAppUrl = environment.whatsapp_url;
  constructor(private route: ActivatedRoute, 
              private router: Router,
              private authService: AuthService) {}
  ngOnInit() {
    this.userNumber = this.route.snapshot.paramMap.get('number') ?? '';
    if (!this.userNumber) {
        window.location.href = this.whatsAppUrl;
      return;
    }
    this.requestRegistration();
    return;
  }
  requestRegistration(){
    this.authService
      .getRegistrationLink(this.userNumber)
      .subscribe({
          next: response => {
           this.isLoadingPageContent = false;
              window.location.href = response.redirectLink;
          },
          error: err => {
            this.isLoadingPageContent = false;
            this.errorMessage = err.error?.message ?? 'Failed to load page';
            this.showAlert = true;
          }
        },
      );
    }
closeErrorPopup(): void {
    window.location.href = this.whatsAppUrl;
  }
}